<template>
    <ui-modal
        :class="css.modal"
        :close-on-click="false"
        ref="modal"
        width="var(--size-1120-992-944)"
        height="auto"
        spacing="32px var(--size-56-56-48) var(--size-48-40-40)">
        <!-- * 标题 -->
        <div :class="css.title" class="color-1 font-bold font-variable">{{ $t("AddASequence") }}</div>

        <!-- * 类型选择 -->
        <div class="bg-color7" :class="[css.radios, css_normalize.radio]">
            <!-- * 输入类型 -->
            <ui-radio-group :class="css.column" v-model="mode" @change="methods.mode">
                <ui-radio :class="css.radio" value="Gene" class="color-1 font-bold"> {{ $t("SearchFromDatabase") }}</ui-radio>
                <ui-radio :class="css.radio" value="Custom" class="color-1 font-bold"> {{ $t("UserDefined") }}</ui-radio>
            </ui-radio-group>
        </div>

        <!-- * 选择序列 -->
        <div class="bg-color7" :class="css.body" v-if="!utils.is_custom(data)">
            <!-- * 基因选择 -->
            <div :class="css.selectors">
                <div :class="css.column">
                    <div :class="css.label">{{ $t("GeneName") }}:</div>
                    <default-search
                        :class="css.search"
                        v-model="keyword"
                        ref="search"
                        type="gene"
                        mode="select"
                        width="100%"
                        :alias="true"
                        :placeholder="$t('SearchByGeneOrNCBI')"
                        @search="methods.change" />
                </div>

                <div :class="css.column">
                    <div :class="css.label">{{ $t("Sequence") }}:</div>
                    <div :class="[css.selects, mane && css.mane]">
                        <!-- * 默认转录本标识 -->
                        <div :class="css.mane" v-if="mane">MANE</div>
                        <!-- * 序列类型选择器 -->
                        <ui-select
                            :class="css.type"
                            v-model="data.seq_type"
                            :width="104"
                            :disabled="!sequences.length"
                            :candidates="seq_types"
                            :z-index="667" />

                        <!-- * 序列选择器 -->
                        <ui-select
                            :class="css.id"
                            v-model="data.tran_pro_id"
                            width="100%"
                            :height="240"
                            :z-index="667"
                            :resolve="() => (data.mode == 'Gene' ? data.tran_pro_id : '')"
                            :disabled="!sequences.length"
                            :candidates="sequences"
                            :class-extra-name="css.candidates"
                            :placeholder="$t('PleaseSelectASequence')"
                            @change="methods.sequence">
                            <template #candidate="{ data }">
                                <div class="ellipsis">
                                    <span :class="css.type">{{ data.type }}</span>
                                    <span>{{ data.label }}</span>
                                </div>
                                <span :class="css.mane" v-if="data.mane">MANE</span>
                            </template>
                        </ui-select>
                    </div>
                </div>
            </div>

            <div :class="css.sequence">
                <div :class="css.label">{{ $t("SelectedSequence") }}:</div>
                <ui-textarea :class="css.input" v-model="sequence" width="100%" :readonly="true" :placeholder="$t('SelectedSequencePlaceholder')" />
            </div>
        </div>

        <!-- * 自定义序列 -->
        <div class="bg-color7" :class="css.custom" v-else>
            <ui-textarea :class="css.input" v-model="sequence" :width="0" :placeholder="$t('PleaseEnterDNASequence')" />
        </div>

        <!-- * 确认按钮 -->
        <div :class="css.footer">
            <ui-button :class="css.confirm" :disabled="!result.data.length" @click="methods.confirm">{{ $t("Confirm") }}</ui-button>
        </div>
    </ui-modal>
</template>

<script lang="tsx" setup>
//* 组件库
import { UiRadio, UiButton, UiSelect, UiTextarea, UiRadioGroup, UiModal } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 组件属性
import { ModuleEmits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
const emits = defineEmits(ModuleEmits);

//* 组合函数
const { refs, nodes, utils, methods, computeds } = useComposable(emits);
const { mane, result, sequences } = computeds;
const { modal, search } = nodes;
const { mode, data, keyword, sequence, seq_types } = refs;

//* 组件属性导出
defineExpose({ open: methods.open });
</script>
